var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isWebComponentReady)?_c('nomad-lk-notifications',{ref:"notificationsRef"}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }